(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.isOnScrollUp = this.getAttribute('data-sticky-type') === 'on-scroll-up';
      this.mainContent = document.getElementById('MainContent');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

     createObserver() {
      // Compute a stable threshold in *document* coordinates,
      // not viewport, so it keeps working if the header flips modes.
      //
      // CRITICAL: only recompute when the header is in its natural (non-sticky)
      // state. When `shopify-section-header-sticky` is applied, the header is
      // `position: fixed; top: 0`, so `getBoundingClientRect().top` is always 0
      // and `scrollY + 0` produces a WRONG document-space top — equal to the
      // current scroll position. That corrupts `headerBounds.top`, and the next
      // upward scroll crossing that position incorrectly calls reset(), which
      // strips the sticky classes and makes the header snap out of view.
      const computeBounds = () => {
        if (this.header.classList.contains('shopify-section-header-sticky')) return;
        const rect = this.header.getBoundingClientRect();
        const y = (window.scrollY || window.pageYOffset) + rect.top;
        this.headerBounds = { top: y, bottom: y + rect.height };
      };
      computeBounds();
      // Recompute when layout can change header size/position
      window.addEventListener('load', computeBounds, { passive: true });
      window.addEventListener('resize', computeBounds, { passive: true });
      window.addEventListener('orientationchange', computeBounds, { passive: true });
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const delta = Math.abs(scrollTop - this.currentScrollTop);
      if (delta < 2) return;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.querySelector('details.mega-menu[open]')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.isOnScrollUp && this.mainContent) {
        this.mainContent.style.paddingTop = this.header.offsetHeight + 'px';
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      // Safety net: refuse to strip the sticky classes unless we're actually
      // at the top of the document. This guards against a corrupted
      // headerBounds.top (see createObserver) causing a mid-page hide.
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > 2) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.isOnScrollUp && this.mainContent) {
        this.mainContent.style.paddingTop = '';
      }
    }

    closeMenuDisclosure() {
  this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
  this.disclosures.forEach(disclosure => disclosure.close());

  // Also close click-toggle details (dropdown and mega menu)
  this.header
    .querySelectorAll('.menu_new--click > details[open]')
    .forEach(d => d.removeAttribute('open'));
}


    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
